import { render, staticRenderFns } from "./FormEditMenuOptional.vue?vue&type=template&id=cc47b4b8"
import script from "./FormEditMenuOptional.vue?vue&type=script&lang=js"
export * from "./FormEditMenuOptional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports